/* KIT stock by location.
   Render ulang widget Kark jadi 2 baris toko dengan badge status.

   Kenapa perlu:
   1. Widget bawaan mencetak angka ("KIT Store JKT - 2 available"), bukan label status.
   2. Widget bawaan tidak ikut berubah saat customer ganti varian, padahal datanya ada.
   3. Lokasi yang tidak punya catatan inventory tidak dicetak sama sekali,
      jadi salah satu toko bisa hilang dari daftar.

   Data diambil dari window.inventoryInfo yang sudah ditaruh app di halaman.
   Tidak ada request tambahan.
*/
(function () {
  /* Nama di sini yang tampil di storefront, bukan nama dari Shopify admin.
     Pencocokan lokasi pakai id, jadi ganti nama di admin tidak akan merusak apa pun. */
  var LOCATIONS = [
    { id: 64111050890, name: 'KIT Jakarta' },
    { id: 89101533322, name: 'KIT Bali' }
  ];

  // 0 = habis, 1-2 = menipis, >2 = ada
  var LOW_MAX = 2;

  function statusOf(qty) {
    if (!qty || qty <= 0) return ['Out of Stock', 'out'];
    if (qty <= LOW_MAX) return ['Low Stock', 'low'];
    return ['In Stock', 'in'];
  }

  function currentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? Number(input.value) : null;
  }

  function variantLocations() {
    var ii = window.inventoryInfo;
    if (!ii || !ii.product) return null;
    var bag = ii[ii.product.handle];
    return bag && bag.data ? bag.data.variantLocations : null;
  }

  function quantitiesFor(variantId) {
    var rows = variantLocations();
    if (!rows || !rows.length) return null;
    var row = null;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].variant === variantId) { row = rows[i]; break; }
    }
    if (!row) row = rows[0];

    var byId = {};
    (row.inventoryLocations || []).forEach(function (l) {
      byId[l.location.id] = l.quantity;
    });
    return byId;
  }

  var painting = false;

  function render() {
    if (painting) return;
    var app = document.getElementById('inventory-info-app');
    if (!app) return;

    var list = app.querySelector('.iia-list');
    if (!list) return;

    var qty = quantitiesFor(currentVariantId());
    if (!qty) return; // data belum siap, biarkan tampilan app apa adanya

    var html = LOCATIONS.map(function (loc) {
      var s = statusOf(qty[loc.id]);
      return '<div class="iia-list-item iia-id-' + loc.id + '">' +
               '<div class="iia-location-info">' +
                 '<div class="iia-title-text">' +
                   '<span class="iia-location">' + loc.name + '</span>' +
                   '<span class="kit-badge kit-badge--' + s[1] + '">' +
                     '<i class="kit-dot" aria-hidden="true"></i>' + s[0] +
                   '</span>' +
                 '</div>' +
               '</div>' +
             '</div>';
    }).join('');

    // jumlah toko yang ada stoknya, gaya sama seperti referensi
    var withStock = LOCATIONS.filter(function (loc) { return (qty[loc.id] || 0) > 0; }).length;
    var countText = withStock + (withStock === 1 ? ' location' : ' locations');

    if (list.innerHTML === html && app.querySelector('.kit-count')) {
      var existing = app.querySelector('.kit-count');
      if (existing.textContent !== countText) existing.textContent = countText;
      return;
    }

    painting = true;
    list.innerHTML = html;

    var head = app.querySelector('.iia-header-container');
    if (head) {
      var badge = head.querySelector('.kit-count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'kit-count';
        head.appendChild(badge);
      }
      badge.textContent = countText;
    }

    app.setAttribute('data-kit-styled', '');
    painting = false;
  }

  function schedule() { setTimeout(render, 60); }

  // render awal, app-nya async jadi dicoba beberapa kali
  var tries = 0;
  var timer = setInterval(function () {
    render();
    if (++tries > 40 || document.querySelector('#inventory-info-app[data-kit-styled]')) clearInterval(timer);
  }, 300);

  // capture phase menangkap event walau tidak bubbling
  document.addEventListener('theme:variant:change', schedule, true);
  document.addEventListener('variant:change', schedule, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) schedule();
  }, true);

  // app kadang menggambar ulang isinya sendiri, pasang lagi kalau itu terjadi
  var appWatch = setInterval(function () {
    var app = document.getElementById('inventory-info-app');
    if (app && app.querySelector('.iia-list') && !app.querySelector('.kit-badge')) render();
  }, 1000);
  setTimeout(function () { clearInterval(appWatch); }, 20000);
})();
